import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

// Communicate with marketing CMS to track user events with Able CDP
const submitAbleCDPEvent = async (event) => {
  const { Aa: token } = firebase.auth().currentUser
  const response = await AxiosConfig.post(
    '/able-cdp/event',
     event,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return response.status === 200
}

export default {
  submitAbleCDPEvent
}